import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components';

import { PT_SERIF } from '../../styles/typography'
import { mediaMax } from '@styles/sizes';

const StyledContent = styled.p`
  font-family: ${PT_SERIF};
  font-size: 24px;
  line-height: 1.5;
  margin-bottom: 16px;
  ${mediaMax.tablet`
    font-size: 18px;
  `}
`;

const StyledAuthor = styled.p`
  font-size: 18px;
`

const Testimonial = ({testimonial, className}) => {
  const {content, author} = testimonial
  return (
    <div>
      <StyledContent className={className}>
        {content}
      </StyledContent>
      <StyledAuthor>
        - {author}
      </StyledAuthor>
    </div>
  )
}

Testimonial.propTypes = {
  testimonial: PropTypes.object.isRequired,
}

export default Testimonial
